module.exports = __webpack_public_path__ + "media/img/Landing_Page/Scholarships2u-Home-Banner-02-1fb135926f150411a5e30d0c586ab26b.jpg";